
<template>
    <div>

        <vxe-modal :width="dialogWidth" height="320" :title="dialogtitle" v-model="dialogChangeVegaVisible" destroy-on-close
            resize transfer draggable v-loading="isLoading">
            <el-form ref="form" :model="form" label-width="100px">
                <!-- <el-form-item label="公司类型">
                    <el-checkbox-group v-model="form.checkboxGroup1">
                        <el-checkbox-button v-for="city in ['上市公司']" :label="city" :key="city">{{city}}</el-checkbox-button>
                    </el-checkbox-group>
                </el-form-item> -->
                <el-form-item label="再融资工具">
                    <el-radio-group v-model="form.checkboxGroup">
                        <el-radio v-for="city in ['发债', '定增', '并购', '重组']" :label="city" :key="city">{{ city }}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="市值管理">
                    <el-radio-group v-model="form.checkboxGroup">
                        <el-radio v-for="city in ['风险管控', '价值推广']" :label="city" :key="city">{{ city }}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="信息披露">
                    <el-radio-group v-model="form.checkboxGroup">
                        <el-radio v-for="city in ['首次披露', '定期报告', '交易类', '公司治理类', '权益变动类', '融资类', '其他']" :label="city"
                            :key="city">{{ city }}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <div style="text-align: center;">
                    <el-button size="small" @click="dialogChangeVegaVisible = false">取消</el-button>
                    <el-button class="btnConfirm" size="small" type="primary"
                        @click="dialogChangeVegaVisible = false">确定</el-button>

                </div>
            </el-form>
        </vxe-modal>
    </div>
</template>

<script>
export default {
    name: "dialogChangeVega",
    data() {
        return {

            dialogChangeVegaVisible: false,
            dialogtitle: "",
            dialogWidth: "600px",
            isLoading: false,
            form: {
                checkboxGroup: '',

            }
        }
    },
    methods: {},

    mounted() { },
    created() {
        this.$EventBus.$on("opendialogChangeVega", (e) => {
            let _params = e._params;
            if (_params) {
                this.dialogtitle = _params.dialogtitle

                // this.dialogWidth=_params.dialogWidth;
            }
            this.dialogChangeVegaVisible = true;

        })

    }
}
</script>

<style>
.btnConfirm {
    color: #FFF !important;
    background-color: #409EFF !important;
    border-color: #409EFF !important;
}
</style>
